import { createContext, useState, useContext, useEffect } from 'react';
import * as api from '../services/api'
import { useLocation, useNavigate } from 'react-router-dom';

const UserContext = createContext();

function UserProvider({ children }) {

    const [userData, setUserData] = useState(() => {
        const storedData = localStorage.getItem('userData');
        return storedData ? JSON.parse(storedData) : null;
    });
      const navigate = useNavigate();
      const location = useLocation();

      const updateUser = (newUserData) => {
          setUserData(newUserData);      
          localStorage.setItem('userData', JSON.stringify(newUserData));
      };

      const getAccountAndNavigate = async () => {
        const response = await api.getUserAccount(false);

        // Si el usuario no está autenticado redirigir al login; si no, a la página actual
        navigate(response.status === 401 ? '/login' : location.pathname)
        //setUserData(response.data || null)
      }

      useEffect(() => {
        getAccountAndNavigate();
      }, [])

      return (
        <UserContext.Provider value={{ userData, updateUser }}>
          {children}
        </UserContext.Provider>
      );
}

function useUserContext() {
   
  const context = useContext(UserContext);
  if (!context) {
    throw new Error('useUser debe usarse dentro de un UserProvider');
  }
  
  return context;
}

export { UserProvider, useUserContext };
